export interface Connection<T> {
  edges?: (Edge<T> | undefined)[]
}

export interface Edge<T> {
  node?: T
  cursor?: string
}

export const getNodesFromConnection = <T>(connection?: Connection<T>): T[] => {
  return (
    connection?.edges
      ?.map(edge => edge?.node)
      .filter(node => node != undefined) ?? []
  )
}

export type ConnectionNode<C extends Connection<any>> = C extends Connection<
  infer T
>
  ? T
  : never
